import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
} from "@mui/material";
import TAGlogo from "assets/images/TAGlogo.svg";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { LoadingModal } from "components/ModalComponent";
import { Link, useNavigate } from "react-router-dom";
import { CreateAccountForm } from "components/Forms";

const Alert = React.forwardRef(function Alert(props, ref) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function UpdateProfile() {
  const navigate = useNavigate();
  const [openAlert, setOpenAlert] = useState(false);
  const [loading, setLoadingBar] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
    navigate("/");
  };
  return (
    <div className="b-login-container">
      <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          className="b-login-container__alert"
        >
          Email or password is wrong!
        </Alert>
      </Snackbar>
      <Box className="b-login-container__box">
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <img
              className="b-login-container__logo"
              src={TAGlogo}
              alt="Error in loading"
            />
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <div className="b-login-container__body">
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          justify="center"
          className="b-login-container__alignment"
        >
          <Grid item xs={12} className="b-login-container__card">
            <Card className="b-login-container__cardHead">
              <CardContent className="b-login-container__content">
                <Typography className="login-card-header">
                  <div className="default-card-header-padding">
                    <h2>Create A New Account</h2>
                  </div>
                </Typography>
              </CardContent>

              <CardContent className="remove b-login-container__cardContent">
                <CreateAccountForm loadingStatusFunc={setLoadingBar} />
              </CardContent>
              <div className="b-login-container__forgotPassText">
                <span className="b-login-container__create-account-text">
                  Already have an account?
                </span>
                <Link
                  className=" dafault-font-famil b-login-container__link"
                  to="/"
                >
                  Log in
                </Link>
              </div>
            </Card>
          </Grid>
        </Grid>
      </div>
      {/* loader */}
      <LoadingModal openLoadingModal={loading} body="Loading" />
    </div>
  );
}
export default UpdateProfile;
